// Menü Board in der Eltern-App, auf Deutsch (siehe boardViewApp.nl.ts).
export const appBoardViewDe = {
    title: 'Board',
    intro: 'So sieht das Board gerade aus, live. Nur ansehen: Tippen geht am Board selbst.',
    choose: 'Board',
    lastSeen: 'Zuletzt gesehen {when}',
    neverSeen: 'Noch nicht gesehen',
    virtual: 'Virtuelles iPad',
    viewOnly: 'Nur ansehen',
    loading: 'Das Board wird geladen…',
    reconnecting: 'Verbindung wird erneuert…',
    revoked: 'Dieses Board wurde getrennt.',
    failed: 'Das Board konnte nicht angezeigt werden.',
    retry: 'Erneut versuchen',
    frameTitle: 'Board {name}, nur ansehen',
    parentsOnly: 'Nur Eltern können das Board hier ansehen.',
    emptyTitle: 'Noch kein Board',
    emptyText: 'Koppel ein Tablet, dann siehst du das Board hier.',
    emptyLink: 'Tablet koppeln',
};
//# sourceMappingURL=boardViewApp.de.js.map